module.exports = __webpack_public_path__ + "static/media/TRIAL 2-if-wrongafter-10-sec.9139a331.mp3";